(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-footer"] && !Shopify.designMode) return;
  try {
    
const footer = document.querySelector('.site-footer');
if (footer && 'IntersectionObserver' in window) {
  new IntersectionObserver(([entry]) => {
    document.body.classList.toggle('gg-footer-in-view', entry.isIntersecting);
  }).observe(footer);
}
// Shop's Follow button loads its own fonts and scripts at top priority, which held back product photos by up to 1.3 s
// on slow phones. It goes in only as the footer nears the screen; scripts are recreated so the browser runs them.
const follow = document.querySelector('[data-follow-on-shop]');
if (follow) {
  const insertFollow = () => {
    const content = follow.content.cloneNode(true);
    content.querySelectorAll('script').forEach(old => {
      const script = document.createElement('script');
      for (const { name, value } of old.attributes) script.setAttribute(name, value);
      script.textContent = old.textContent;
      old.replaceWith(script);
    });
    follow.replaceWith(content);
  };
  if ('IntersectionObserver' in window) {
    const watch = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      watch.disconnect();
      insertFollow();
    }, { rootMargin: '600px 0px' });
    watch.observe(follow.parentElement);
  } else insertFollow();
}

  } catch(e) { console.error(e); }
})();
})();
